module.exports = __webpack_public_path__ + "img/file-type-sheet-alt.01ddfdc9.svg";